import styled from "@emotion/styled";

export const DatePickerTextInputPlaceholderInvisible = styled("span")`
    color: transparent;
`;
